import { useState } from 'react';
import useToast from 'components/Provider/useToast';
import { myDocumentsDelete, myDocumentPublish, myDocumentUnPublish } from 'api/documents';
import get from 'lodash/get';
import { useNavigate } from 'react-router-dom';
import downloadFile from 'utils/downloadFile';

const useMyDocumentService = () => {
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const [refreshDocumentList, setRefreshDocumentList] = useState(false);
  const addToast = useToast();
  const navigate = useNavigate();

  const viewDocument = (row) => {
    const id = get(row, 'id', '');
    navigate(`/home/documents/view/${id}`);
  };

  const handleAttachment = async (row) => {
    try {
      await downloadFile({ docid: row?.id }, row?.fileName, 'restPayIndex/downloadAttachment');
    } catch (err) {
      addToast({
        type: 'error',
        title: 'ERROR',
        message: err.message || `Failed to download attachment`,
      });
    }
  };

  const editDocument = (row) => {
    const id = get(row, 'id', '');
    navigate(`/home/documents/edit/${id}`);
  };

  const handleDeleteDialog = () => {
    setShowDeleteDialog(!showDeleteDialog);
  };

  const deleteDocument = async (row) => {
    try {
      const bodyFormData = new FormData();
      bodyFormData.append('id', get(row, 'id', ''));
      const response = await myDocumentsDelete(bodyFormData);
      if (response.status === 'SUCCESS') {
        addToast({ type: 'success', title: 'SUCCESS', message: response?.message });
        setRefreshDocumentList(!refreshDocumentList);
      } else {
        addToast({ type: 'error', title: 'ERROR', message: response?.message });
      }
    } catch (error) {
      addToast({ type: 'error', title: 'ERROR', message: error?.message });
    } finally {
      handleDeleteDialog(false);
    }
  };

  const handlePublishDocument = async (row) => {
    try {
      const bodyFormData = new FormData();
      bodyFormData.append('id', get(row, 'id', ''));
      const response = await myDocumentPublish(bodyFormData);
      if (response.status !== 'ERROR') {
        addToast({ type: 'success', title: 'SUCCESS', message: response?.message });
        setRefreshDocumentList(!refreshDocumentList);
      }
    } catch (error) {
      addToast({ type: 'error', title: 'ERROR', message: error?.message });
    }
  };

  const handleUnPublishDocument = async (row) => {
    try {
      const bodyFormData = new FormData();
      bodyFormData.append('id', get(row, 'id', ''));
      const response = await myDocumentUnPublish(bodyFormData);
      if (response.status !== 'ERROR') {
        addToast({ type: 'success', title: 'SUCCESS', message: response?.message });
        setRefreshDocumentList(!refreshDocumentList);
      }
    } catch (error) {
      addToast({ type: 'error', title: 'ERROR', message: error?.message });
    }
  };

  return {
    deleteDocument,
    showDeleteDialog,
    handleDeleteDialog,
    refreshDocumentList,
    handlePublishDocument,
    handleUnPublishDocument,
    viewDocument,
    editDocument,
    handleAttachment,
  };
};

export default useMyDocumentService;
